<ul class="top-menu" nz-menu nzMode="horizontal">
  <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: menu$ | async }"></ng-container>
  <ng-template #menuTpl let-menus>
    <ng-container *ngFor="let menu of menus; let i=index;">
      <nz-divider nzType="vertical" *ngIf="i!==0"></nz-divider>
      <li *ngIf="!menu.command" [id]="menu.id">
        <ng-container *ngTemplateOutlet="menu.iconRef;"><i nz-icon [nzType]="menu.iconRef" *ngIf="menu.iconRef"></i></ng-container>
        <i nz-icon [nzType]="menu.icon" *ngIf="menu.icon"></i>
        <span>{{ menu.title }}</span>
      </li>
      <li *ngIf="menu.command && !menu.children" nz-menu-item (click)="menu.command()" nzTheme="dark" [id]="menu.id">
        <ng-container *ngTemplateOutlet="menu.iconRef;"><i nz-icon [nzType]="menu.iconRef" *ngIf="menu.iconRef"></i></ng-container>
        <i nz-icon [nzType]="menu.icon" *ngIf="menu.icon"></i>
        <span>{{ menu.title }}</span>
      </li>
      <ng-container *ngIf="menu.command && menu.children">
        <li 
          nz-menu-item 
          nz-dropdown 
          [nzDropdownMenu]="myAccountMenu" 
          nzOverlayClassName="hills-dropdown-menu"
          [id]="menu.id">
          <ng-container *ngTemplateOutlet="menu.iconRef;"><i nz-icon [nzType]="menu.iconRef" *ngIf="menu.iconRef"></i></ng-container>
          <i nz-icon [nzType]="menu.icon" *ngIf="menu.icon"></i>
          <span>{{ menu.title }}</span>
        </li>
        <nz-dropdown-menu #myAccountMenu="nzDropdownMenu" id="my-account-dropdown">
          <ul nz-menu [nzSelectable]="false">
            <li *ngFor="let child of menu.children" nz-menu-item [id]="child.id" (click)="child.command()"><i [class]="child.icon"></i>{{child.title}}</li>
          </ul>
        </nz-dropdown-menu>
      </ng-container>
    </ng-container>
  </ng-template>
</ul>

<ng-template #badge>
  <app-cart-badge-container
    [badgeStyle]="badgeStyle"
  >
  </app-cart-badge-container>
</ng-template>
